import {
  hm5VersionListConstants,
  hm5VersionUploadConstants,
  hm5VersionDeleteConstants,
  hm5VersionConstants,
} from "../_redux-constants";
import { hm5VersionListService } from "../../_services";

function getHM5VersionList(queryParams) {
  function getHM5VersionListLoad() {
    return { type: hm5VersionListConstants.HM5VERSION_LIST_LOADING };
  }
  function hm5VersionListSuccess(data) {
    return { type: hm5VersionListConstants.HM5VERSION_LIST_SUCCESS, data };
  }
  function hm5VersionListFailure(error) {
    return { type: hm5VersionListConstants.HM5VERSION_LIST_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getHM5VersionListLoad());
    return hm5VersionListService.getHM5VersionList(queryParams).then(
      (data) => {
        dispatch(hm5VersionListSuccess(data));
      },
      (error) => {
        dispatch(hm5VersionListFailure(error?.toString()));
      }
    );
  };
}

function uploadHM5Version(queryParams) {
  function hm5VersionUploadLoad() {
    return { type: hm5VersionUploadConstants.HM5VERSION_UPLOAD_LOADING };
  }
  function hm5VersionUploadSuccess(data) {
    return { type: hm5VersionUploadConstants.HM5VERSION_UPLOAD_SUCCESS, data };
  }
  function hm5VersionUploadFailure(error) {
    return { type: hm5VersionUploadConstants.HM5VERSION_UPLOAD_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(hm5VersionUploadLoad());
    return new Promise((resolve, reject) => {
      hm5VersionListService.uploadHM5Version(queryParams).then(
        (data) => {
          dispatch(hm5VersionUploadSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(hm5VersionUploadFailure(error));
          reject(error);
        }
      );
    });
  };
}

function deleteHM5Version(queryParams) {
  function hm5VersionDeleteLoad() {
    return { type: hm5VersionDeleteConstants.HM5VERSION_DELETE_LOADING };
  }
  function hm5VersionDeleteSuccess(data) {
    return { type: hm5VersionDeleteConstants.HM5VERSION_DELETE_SUCCESS, data };
  }
  function hm5VersionDeleteFailure(error) {
    return { type: hm5VersionDeleteConstants.HM5VERSION_DELETE_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(hm5VersionDeleteLoad());
    return hm5VersionListService.deleteHM5Version(queryParams).then(
      (data) => {
        dispatch(hm5VersionDeleteSuccess(data));
      },
      (error) => {
        dispatch(hm5VersionDeleteFailure(error?.toString()));
      }
    );
  };
}

function hm5Version(queryParams) {
  function hm5VersionLoad() {
    return { type: hm5VersionConstants.HM5VERSION_LOADING };
  }
  function hm5VersionSuccess(data) {
    return { type: hm5VersionConstants.HM5VERSION_SUCCESS, data };
  }
  function hm5VersionFailure(error) {
    return { type: hm5VersionConstants.HM5VERSION_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(hm5VersionLoad());
    return hm5VersionListService.showhm5Version(queryParams).then(
      (data) => {
        dispatch(hm5VersionSuccess(data));
      },
      (error) => {
        dispatch(hm5VersionFailure(error?.toString()));
      }
    );
  };
}

export const hm5VersionListActions = {
  getHM5VersionList,
  uploadHM5Version,
  deleteHM5Version,
  hm5Version,
};
